import { Camera, Object3D } from 'three';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { MaterialService } from '../material.service';
import { RendererLayer } from '../render-utils';

export interface RenderConfiguration {
  areProjectionsEnabled: boolean;
  cameraLayer: RendererLayer;
  camera: Camera;
  outputName: string;
  // To be removed when new-edit-panel FF is promoted
  isUsingNewEditPanels?: boolean;
  // To be removed when hide-cuboid-vertices FF is promoted
  areCuboidVerticesHidden?: boolean;
}

export interface ConfigureMeshesConfiguration extends RenderConfiguration {
  state: PointCloudContentState;
  materialService: MaterialService;
}

export abstract class AbstractMeshHelper {
  prepareToRender(
    config: RenderConfiguration,
    state: PointCloudContentState,
    materialService: MaterialService,
  ) {
    this.updateRendererLayers(state, config);
    if (this.isVisibleInLayer(config.cameraLayer)) {
      this.configureMeshes({
        ...config,
        state,
        materialService,
      });
    }
  }

  private isVisibleInLayer(cameraLayer: RendererLayer) {
    return this.getMeshes().some((mesh) => mesh.layers.isEnabled(cameraLayer));
  }

  abstract getMeshes(): Object3D[];

  abstract dispose(): void;

  protected abstract updateRendererLayers(
    state: PointCloudContentState,
    config: RenderConfiguration,
  ): void;

  protected abstract configureMeshes(
    config: ConfigureMeshesConfiguration,
  ): void;
}
